//https://stackoverflow.com/questions/8188548/splitting-a-js-array-into-n-arrays
export const splitToChunks = (array, parts) => {
  let result = [];
  for (let i = parts; i > 0; i--) {
    result.push(array.splice(0, Math.ceil(array.length / i)));
  }
  return result;
};
